import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    menuWrapper: {
      padding: 0,
      maxHeight: 556,
    },
    buttonsWrapper: {
      padding: theme.spacing(2),
    },
    listItemSub: {
      height: 'unset',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-evenly',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.gray.gray50,
      gap: theme.spacing(0.5),
      '& p': {
        maxWidth: 270,
        width: '100%',
      },
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
    },
    listItemSubNoHover: {
      '&:hover': {
        backgroundColor: 'unset',
        cursor: 'default',
      },
    },
    emptyState: {
      padding: theme.spacing(0, 2, 0),
      minHeight: 20,
      backgroundColor: 'unset',
      cursor: 'default',
      '&:hover': {
        backgroundColor: 'unset',
      },
      '& > p': {
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(20),
        color: COLORS.neutral.mediumGray,
      },
    },

    title: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(14),
      padding: theme.spacing(0, 0, 0, 1),
      backgroundColor: 'unset !important',
      minHeight: 20,
      cursor: 'default',
      '&:hover': {
        backgroundColor: 'unset',
      },
      '&  p': {
        color: COLORS.gray.gray40,
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(14),
      },
    },

    createButton: {
      backgroundColor: 'unset',
      cursor: 'pointer',
      borderRadius: 0,
      marginBottom: theme.spacing(1.25),
      paddingTop: 0,
      borderBottom: theme.shape.borderGray70,
      '&:hover': {
        backgroundColor: 'unset',
        textDecoration: 'underline',
      },

      '& > p': {
        marginBottom: theme.spacing(0.5),
        color: COLORS.primary.active,
        '&:hover': {
          textDecoration: 'underline',
        },
      },
      '&:last-child': {
        border: 'none',
        marginBottom: 0,
        paddingBottom: 0,
      },
    },
    menuIcon: {
      display: 'flex',
      width: '100%',
    },
    assetIcon: {
      color: COLORS.gray.gray30,
    },
    resourceItem: { textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' },
    label: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.neutral.black,
      fontWeight: theme.typography.fontWeightMedium,
    },
    menuList: {
      width: 'fit-content',
      minWidth: 420,
      maxWidth: 420,
    },
    menuListImage: {
      width: 'fit-content',
      minWidth: 420,
      maxWidth: 420,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: theme.spacing(1.75),
      paddingTop: theme.spacing(0.75),
    },
    menuCardsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: theme.spacing(1),
    },
    menuCards: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(1),
      flexWrap: 'wrap',
    },
    addButton: {
      backgroundColor: COLORS.gray.gray90,
      '&:hover': {
        backgroundColor: COLORS.primary.silver,
      },
      color: COLORS.primary.default,
      width: '100%',
      marginBottom: theme.spacing(1.5),
      fontWeight: theme.typography.fontWeightMedium,
    },
    addIcon: { color: COLORS.primary.primary },
    searchWrapper: {
      padding: theme.spacing(1, 2, 0.5),
    },
    searchField: {
      width: '100%',
      marginBottom: theme.spacing(0.5),
      height: 40,
      '& $extraMarginBottom': {
        marginBottom: theme.spacing(1.5),
      },
    },
    extraMarginBottom: {},
  }),
  { name: 'PromptMenu' }
);
